var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "score_cercle_w"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_record" },
        React.createElement(
          "g",
          { id: "item_score" },
          React.createElement(
            "g",
            { id: "score_7" },
            React.createElement(
              "g",
              { id: "score_cercle_w" },
              React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M12 2A10 10 0 1 1 2 12 10 10 0 0 1 12 2m0-2a12 12 0 1 0 12 12A12 12 0 0 0 12 0z", id: "item_cercle_w1" }),
              React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M12 6a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-2a8 8 0 1 0 8 8 8 8 0 0 0-8-8z", id: "item_cercle_w2" })
            )
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/icon/images/status4.svg
// module id = 1058
// module chunks = 0